import { RouteObject } from 'react-router-dom';
import { AccountPageComponent } from '@/features/account/account.page';

export default [
	{
		path: 'account',
		element: <AccountPageComponent />,
	},
] as RouteObject[];
